module.exports = __webpack_public_path__ + "static/media/U1-T2-2-2c.e869e31a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/U1-T2-2-2c.svg
// module id = 542
// module chunks = 0